export enum ItemType{
    StandaloneItem = 1,
    Extra = 2, //this is milk Sku into POS
    //BomMilk = 3, //this is milk Sku into Recipes
    Removal = 4,
    Swap = 5, // used for items that are swapped, one added, another removed or reduced in qty
    Transition = 20,
    Substitution = 30,
}